export enum ExamStatus {
  SUCCEEDED = 'SUCCEEDED',
  IN_PROGRESS = 'IN_PROGRESS',
  PENDING = 'PENDING',
  FAILED = 'FAILED',
  EXPIRED = 'EXPIRED',
  UNREAD = 'UNREAD',
}

export function isExamStatusDone(status: ExamStatus): boolean {
  return [ExamStatus.SUCCEEDED, ExamStatus.FAILED].includes(status);
}
